import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import ReactModal, { Props } from 'react-modal'
// type State = {}

export const Modal: React.FC<Props & { title?: string }> = ({
  title,
  children,
  ...props
}) => {
  return (
    <ReactModal
      className="bg-white rounded-lg pc:w-1/2 focus:outline-none z-30 pc:w-4/12 mx-4"
      overlayClassName="flex items-center justify-center fixed left-0 bottom-0 w-full h-full bg-gray-800 bg-opacity-50 z-30"
      {...props}
    >
      <div className="flex flex-col items-start py-8 px-4">
        {title && (
          <>
            <div className="flex items-center w-full">
              <div className="flex justify-center mx-auto text-blue-900 font-medium text-lg font-bold">
                <FontAwesomeIcon
                  className="mt-1 mr-2"
                  style={{ fontSize: 18 }}
                  icon={faExclamationTriangle}
                />
                {title}
              </div>
            </div>
            <hr />
          </>
        )}
        {children}
      </div>
    </ReactModal>
  )
}
